<div  [id]="'pendo-myon-skill-' + category" class="action-link-section">
  <div class="link-description">{{myONLink.description}}</div>
  <a id="nav-help" (click)="navigateMyONByLaunchControl($event, myONLink.link)" [href]="myONLink.link" attr.aria-label="{{myONLink.name}} (opens in a new tab)"
    class="action-link other-action-link" target="_blank" rel="noopener noreferrer">
    <img [src]="myONLink.imageUrl" alt="" class="other-action-logo" />
    <span class="link-name">{{myONLink.name}}</span>
    <span class="glyph glyph-externallink"></span>
  </a>
</div>
